module.exports = __webpack_public_path__ + "img/Tsang.bd881006.jpeg";